import { CollegeEnum } from '@fasstech/oip-core/entities/enums';
import { find, propEq, propOr } from 'ramda';

export const collegeOptions = [
  { label: 'Ensemble du personnel', value: CollegeEnum.ALL },
  { label: 'Cadres', value: CollegeEnum.EXECUTIVE_EMPLOYEES },
  { label: 'Non cadres', value: CollegeEnum.EMPLOYEES }
];

export const getCollegeLabel = (value) => {
  const option = find(propEq('value', value), collegeOptions);
  return propOr(value, 'label', option);
};
